import { render, staticRenderFns } from "./NewUpdateCmp.vue?vue&type=template&id=379a48b7&scoped=true&"
import script from "./NewUpdateCmp.vue?vue&type=script&lang=js&"
export * from "./NewUpdateCmp.vue?vue&type=script&lang=js&"
import style0 from "./NewUpdateCmp.vue?vue&type=style&index=0&id=379a48b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a48b7",
  null
  
)

export default component.exports